/* KE cart drawer behaviours (2026-09-11). Custom elements so they re-init after Dawn swaps the drawer HTML. */
(function () {
  if (!customElements.get('ke-dispatch-timer')) {
    customElements.define('ke-dispatch-timer', class extends HTMLElement {
      connectedCallback() { this.tick(); this._t = setInterval(() => this.tick(), 1000); }
      disconnectedCallback() { clearInterval(this._t); }
      etParts() {
        const f = new Intl.DateTimeFormat('en-US', { timeZone: this.dataset.tz || 'America/New_York', hour12: false, weekday: 'short', hour: 'numeric', minute: 'numeric', second: 'numeric' });
        const p = {}; f.formatToParts(new Date()).forEach(x => (p[x.type] = x.value));
        return { wd: p.weekday, h: Number(p.hour) % 24, m: Number(p.minute), s: Number(p.second) };
      }
      tick() {
        const cutoff = Number(this.dataset.cutoff || 14); const { wd, h, m, s } = this.etParts();
        const weekday = !['Sat', 'Sun'].includes(wd);
        const secsLeft = (cutoff * 3600) - (h * 3600 + m * 60 + s);
        if (weekday && secsLeft > 0) {
          const hh = Math.floor(secsLeft / 3600), mm = Math.floor((secsLeft % 3600) / 60), ss = secsLeft % 60;
          this.innerHTML = 'Order within <span class="ke-dr-cd">' + hh + ':' + String(mm).padStart(2, '0') + ':' + String(ss).padStart(2, '0') + '</span> to ship today';
        } else if (wd === 'Fri' || wd === 'Sat' || wd === 'Sun') {
          this.textContent = 'Order now — ships Monday';
        } else {
          this.textContent = 'Order now — ships next business day';
        }
      }
    });
  }

  if (!customElements.get('ke-essential')) {
    customElements.define('ke-essential', class extends HTMLElement {
      connectedCallback() {
        const sel = this.querySelector('.ke-dr-ess-sel'), btn = this.querySelector('.ke-dr-ess-add');
        if (sel && btn) sel.addEventListener('change', () => { btn.dataset.variantId = sel.value; btn.dataset.size = sel.options[sel.selectedIndex].text; });
      }
    });
  }


  if (!customElements.get('ke-auto-slider')) {
    // Continuous glide (px/s), seamless loop by duplicating the cards. Pauses on hover/touch,
    // yields to the user's own scrolling for a few seconds, skips under reduced-motion.
    customElements.define('ke-auto-slider', class extends HTMLElement {
      connectedCallback() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this._speed = Number(this.dataset.speed || 34);
        this._hold = 0; this._hover = false; this._last = null; this._raf = null;
        const hold = (ms) => { this._hold = performance.now() + ms; };
        this.addEventListener('pointerenter', () => (this._hover = true));
        this.addEventListener('pointerleave', () => (this._hover = false));
        this.addEventListener('pointerdown', () => hold(4000));
        this.addEventListener('wheel', () => hold(4000), { passive: true });
        this.addEventListener('touchstart', () => hold(4000), { passive: true });
        this.addEventListener('touchmove', () => hold(4000), { passive: true });
        this.addEventListener('touchend', () => hold(3000), { passive: true });
        requestAnimationFrame(() => this.init());
      }
      disconnectedCallback() { cancelAnimationFrame(this._raf); }
      init() {
        if (!this.isConnected || this.scrollWidth <= this.clientWidth + 4) return;
        if (!this._dup) {
          const kids = Array.from(this.children);
          this._loopW = kids.reduce((w, k) => w + k.getBoundingClientRect().width, 0) + 10 * kids.length;
          // three copies; we live in the middle one so a finger can drag left OR right at any time
          for (let n = 0; n < 2; n++) kids.forEach((k) => { const c = k.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.dataset.clone = '1'; this.appendChild(c); });
          this._dup = true;
          this.style.scrollSnapType = 'none';
          this.scrollLeft = this._loopW;
        }
        this._raf = requestAnimationFrame((t) => this.tick(t));
      }
      tick(now) {
        if (!this.isConnected) return;
        if (this._last == null) this._last = now;
        const dt = Math.min(0.05, (now - this._last) / 1000); this._last = now;
        if (!this._hover && now > this._hold) {
          // float position; scrollLeft is integer-rounded by the browser, so never accumulate on it
          if (this._pos == null || Math.abs(this._pos - this.scrollLeft) > 2) this._pos = this.scrollLeft;
          this._pos += this._speed * dt;
          // keep the window inside the middle copy (identical content, so the jump is invisible)
          if (this._pos >= 2 * this._loopW) this._pos -= this._loopW;
          if (this._pos < this._loopW) this._pos += this._loopW;
          const next = Math.round(this._pos);
          if (next !== this.scrollLeft) this.scrollLeft = next;
        } else {
          this._pos = null;
        }
        this._raf = requestAnimationFrame((t) => this.tick(t));
      }
    });
  }

  // CHECKOUT in the drawer goes straight to checkout — never via the /cart page (Tyler 2026-09-11)
  document.addEventListener('click', (e) => {
    const b = e.target && e.target.closest && e.target.closest('#CartDrawer-Checkout');
    if (!b || b.disabled) return;
    e.preventDefault();
    b.disabled = true;
    b.dataset.keNav = '1';
    // backstop: if the navigation never commits (Back/Stop before checkout loads), re-arm the button
    setTimeout(() => { if (b.isConnected && b.dataset.keNav) { b.disabled = false; delete b.dataset.keNav; } }, 8000);
    window.location.href = '/checkout';
  });

  // Back from checkout: the browser can restore this page from the back-forward cache with CHECKOUT
  // still disabled (a dead button until a reload or a cart edit). Re-arm only the button WE disabled;
  // an empty cart renders it disabled on purpose.
  window.addEventListener('pageshow', (e) => {
    if (!e.persisted) return;
    document.querySelectorAll('#CartDrawer-Checkout[data-ke-nav]').forEach((b) => {
      b.disabled = false;
      delete b.dataset.keNav;
    });
  });

  // close on overlay tap after Dawn re-renders (#CartDrawer innerHTML swap drops the listener)
  document.addEventListener('click', (e) => {
    if (e.target && e.target.id === 'CartDrawer-Overlay') document.querySelector('cart-drawer')?.close?.();
  });
})();
